import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ArchiveCatalogNameRule } from '../models/archive/archive-catalog-name-rule.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class ArchiveCatalogNameRuleService extends RequestService<ArchiveCatalogNameRule> {
  static PATH = '/archive/catalog/name/rule';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(
      httpClient,
      ArchiveCatalogNameRuleService.PATH,
      globalService.debugUrl
    );
  }
}
